import { Component, OnInit, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { Helpers } from '../../../helpers';
import { ApiService } from '../../pages/api-service.service';
import { Router, Routes, RouterModule } from '@angular/router';
import { AuthenticationService } from '../../../auth/_services/authentication.service';


declare let mLayout: any;
@Component({
    selector: "app-aside-nav",
    templateUrl: "./aside-nav.component.html",
    encapsulation: ViewEncapsulation.None,
})
export class AsideNavComponent implements OnInit, AfterViewInit {
    public _username;
    isLoggedIn: boolean;

    constructor(public apiService: ApiService, public auth: AuthenticationService, public router: Router) {
        // this.isLoggedIn = false;
    }

    hide() { this.isLoggedIn = false; }

    show() { this.isLoggedIn = true; }



    ngOnInit() {
        this.loadusername();
     }

    loadusername() {
        Helpers.setLoading(true); 
        let user = JSON.parse(localStorage.getItem('currentUser'));
        if (user != null) {
            this.apiService.getUserById(user.userid).subscribe(result => {
                let d =  result;
                if (d['role'] == 'Server Admin' || d['role'] == 'Site Administrator') {
                    this.show();
                }
                else {
                    this.hide();
                }
                Helpers.setLoading(false);
            },
            error =>{
                this.outsession(error)
            }
        );
        }
        else {
            this.logout();
        }
    }
   
    outsession(data) {
        if (data == 0) {
            localStorage.removeItem('currentUser');
            this.router.navigate(['/login'])
        }
    }


    logout() {
        const user = JSON.parse(localStorage.getItem('currentUser'));
        if (user) {
            localStorage.removeItem('currentUser');
            this.router.navigate(['/login']);
            this._username = '';
            this.hide();
        }
    }

 
    
    ngAfterViewInit() {
        mLayout.initAside();
    }

}



// WEBPACK FOOTER //
// D:/Finca/Finca UI/UI/src/app/theme/layouts/aside-nav/aside-nav.component.ts